
exports.shortenWalletAddress = (address) => {
    if(address){
        let shortenedAddress = '';    
        shortenedAddress = address.substr(0,6)+'......'+address.substr(address.length - 4,address.length);    
        return shortenedAddress;
    }
};